import { getSettingsWorkplacesApi as generatedGetSettingsWorkplacesApi } from '../generated/settingsWorkplaces/getSettingsWorkplaces';

const getSettingsWorkplacesApi = generatedGetSettingsWorkplacesApi.enhanceEndpoints({
  endpoints: {
    getSettingsWorkplaces: {
      providesTags: ['SettingsWorkplaces'],
    },
  },
});

export const { useGetSettingsWorkplacesQuery } = getSettingsWorkplacesApi;
